import "core-js/modules/es.function.name";
import _defineProperty from "C:\\Users\\frontend\\Desktop\\Piaf-Vue 2\\Piaf-Vue\\node_modules\\@babel\\runtime-corejs3/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import db from "@/components/firebaseInit";
import firebase from "firebase";
import axios from "axios";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { validationMixin } from "vuelidate";

var _require = require("vuelidate/lib/validators"),
    required = _require.required;

export default {
  components: {
    "quill-editor": quillEditor
  },
  data: function data() {
    var _ref;

    return _ref = {
      content: "",
      editorOption: {// some quill options
      },
      imageData: null,
      picture: null,
      uploadValue: 0,
      selectOptions: ["", "Option1", "Option2", "Option3", "Option4", "Option5"],
      blog_id: "",
      title: "",
      date: "",
      select: ""
    }, _defineProperty(_ref, "content", ""), _defineProperty(_ref, "image", ""), _ref;
  },
  mixins: [validationMixin],
  validations: {
    title: {
      required: required
    },
    date: {
      required: required
    },
    select: {
      required: required
    },
    content: {
      required: required
    },
    blog_id: {
      required: required
    }
  },
  methods: {
    onValitadeFormSubmit: function onValitadeFormSubmit() {
      var _this = this;

      console.log("submit!");
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        // do your submit logic here
        this.picture = null;
        var storageRef = firebase.storage().ref("blog/".concat(this.imageData.name)).put(this.imageData);
        storageRef.on("state_changed", function (snapshot) {
          _this.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        }, function (error) {
          console.log(error.message);
        }, function () {
          _this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then(function (url) {
            _this.picture = url;

            _this.saveBlog(url);
          });
        });
      }

      console.log(JSON.stringify({
        title: this.title,
        blog_id: this.blog_id,
        date: this.date,
        select: this.select,
        content: this.content
      }));
    },
    saveBlog: function saveBlog(url) {
      var _this2 = this;

      this.image = url;
      db.collection("blogs").add({
        blog_id: this.blog_id,
        title: this.title,
        date: this.date,
        content: this.content,
        image: this.image
      }).then(function (docRef) {
        console.log("blog added: ", docRef.id);

        _this2.$notify("success", "Add Blog success", "", {
          duration: 3000,
          permanent: false
        });

        _this2.$router.push("/app/pages/product/thumb-list");
      }).catch(function (error) {
        console.error("Error adding blog: ", error);
      });
    },
    onEditorChange: function onEditorChange(_ref2) {
      var quill = _ref2.quill,
          html = _ref2.html,
          text = _ref2.text;
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
    previewImage: function previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
    }
  },
  watch: {}
};